<template>
  <div>
    <div class="py-3 px-5 bg-white rounded-xl shadow-lg mx-4">
      <div class="grid grid-cols-2" @click="showFilters = !showFilters">
        <div class="flex items-center gap-4">
          <a-icon type="filter" class="text-lg ml-2"></a-icon>
          <h2 class="text-left text-lg text-gray-600">
            <b>Filtros de búsqueda</b>
          </h2>
        </div>
        <span
          class="h-5 w-5 m-2 flex justify-center items-center transition justify-self-end"
          :class="{ 'transform rotate-180': showFilters }"
        >
          <a-icon type="caret-down" class="text-xl my-auto" />
        </span>
      </div>
      <a-divider v-if="showFilters" class="mt-2 mb-2"></a-divider>
      <div
        class="flex gap-5 flex-wrap relative w-full border-box"
        v-show="showFilters"
      >
        <form id="filterSupportForm" @submit.prevent="submitForm">
          <div
            class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4 relative"
          >
            <!--Entidad -->
            <BaseSelect
              ref="entidad"
              id="entidad"
              label="Entidad"
              :selectOptions="customEntities"
              v-model="form.entidad"
              :loading="loading"
            />

            <!--Motivo -->
            <BaseSelect
              ref="motivo"
              id="motivo"
              label="Motivo"
              :selectOptions="formOptions.optionsReasonsAgiliza"
              v-model="form.motivo_queja"
              :loading="loading"
            />

            <!--Nombre -->
            <BaseInput
              type="text"
              label="Código de queja"
              placeholder="Ej: 26598965472981"
              v-model="form.codigo_queja"
            />

            <!--Estado de la sesión - multiple -->
            <BaseMultiSelect
                :valuesSelected="void_array"
              title="Estado de la sesión"
              :data="customStatesSessions"
              label="name"
              @notify-objects="setMultiSelect($event)"
            />
            <!-- Fecha de sesión. -->
            <BaseRangeDate
              ref="fecha_de_sesion"
              label="Fecha de sesión"
              :value="
                form.sesion_start && form.sesion_end
                  ? [form.sesion_start, form.sesion_end]
                  : null
              "
              @notify-dates="setRangeDateSession($event)"
            />
            <!-- Fecha de creación. -->
            <BaseRangeDate
              ref="fecha_de_creacion"
              label="Fecha de creación"
              :value="
                form.creation_start && form.creation_end
                  ? [form.creation_start, form.creation_end]
                  : null
              "
              @notify-dates="setRangeDate($event)"
            />

            <!--Tipo de identificación -->
            <BaseSelect
              ref="tipo_documento"
              id="tipo_documento"
              label="Tipo de identificación"
              :selectOptions="customIdentificationType"
              v-model="form.identification_type"
              :loading="loading"
            />

            <!--Número de identificación -->
            <BaseNumber
              label="No. de identificación"
              placeholder="Ej: 123456789"
              v-model="form.identification_number"
              :doNotValidateNit="true"
            />

            <!--Nombre -->
            <BaseInput
              type="text"
              label="Nombre"
              placeholder="Ej: Juan Pérez"
              v-model="form.name"
            />

            <!--Correo electrónico -->
            <BaseInput
              type="text"
              label="Correo electrónico"
              placeholder="Ej: andres.perez@example.com"
              v-model="form.email"
            />
          </div>

          <div class="w-full flex justify-end self-end gap-4 mt-5 mb-3">
            <a-button
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
              type="primary"
              ghost
              shape="round"
              @click="clearFilters"
            >
              Limpiar
            </a-button>

            <a-button
              :disabled="searching ? true : false"
              type="primary"
              shape="round"
              @click="submitForm"
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
            >
              <a-icon type="search" v-if="!searching"></a-icon>
              {{ searching ? "BUSCANDO..." : "BUSCAR" }}
            </a-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "@/core/utils/constants";

export default {
  props: ["loading", "searching","userFacilitatorId"],
  data() {
    return {
      form: {
        codigo_queja: "",
        entidad: "",
        motivo_queja: "",         
        session_state_agiliza: [],
        name: "",
        identification_type: "",
        identification_number: "",
        email: "",
        is_receiving_scheduling: "",
        creation_start: "",
        creation_end: "",
        sesion_start: "",
        sesion_end: "",
        user_id_facilitator: this.userFacilitatorId || "",
      },
      showFilters: false,
      void_array: [],
    };
  },
  created() {
    this.initializeForm();     
  },
  async mounted() {
    // Solo emitimos el formulario inicial para que el padre tenga los valores por defecto,
    // pero no disparamos la búsqueda (submitForm) aquí si el padre ya tiene un watch
    // que ejecutará fetchData.
    const pagination = {};
    this.$emit("getFilterForm", this.form, pagination);
  },
  methods: {
    async submitForm() {
      const isReceivingScheduling =
        this.form.is_receiving_scheduling === "1"
          ? true
          : this.form.is_receiving_scheduling === "2"
          ? false
          : "";

      const formToSubmit = {
        ...this.form,
        session_state_agiliza: this.form.session_state_agiliza.join(","),
        is_receiving_scheduling: isReceivingScheduling,
      };
      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", formToSubmit, pagination);
    },
    async clearFilters() {
      this.initializeForm();

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    initializeForm() {
      const startDate = moment().subtract(30, "d").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");
      this.void_array = [];
      this.form = {
        codigo_queja: "",
        entidad: "",
        motivo_queja: "",         
        session_state_agiliza: [],
        name: "",
        identification_type: "",
        identification_number: "",
        email: "",
        is_receiving_scheduling: "",
        creation_start: startDate,
        creation_end: endDate,
        sesion_start: "",
        sesion_end: "",
        user_id_facilitator: this.userFacilitatorId || ""
      };
    },
    setRangeDate(eventValue) {
      this.form.creation_start = eventValue ? eventValue[0] : "";
      this.form.creation_end = eventValue ? eventValue[1] : "";
    },
    setRangeDateSession(eventValue) {
      this.form.sesion_start = eventValue ? eventValue[0] : "";
      this.form.sesion_end = eventValue ? eventValue[1] : "";
    },
    setMultiSelect(ev) {
      this.form.session_state_agiliza = ev.map((item) => item.id);
    },
  },
  watch: {
    userFacilitatorId: {
      handler(newVal) {
        this.form.user_id_facilitator = newVal || "";
        // No llamamos a submitForm() aquí porque el padre ya tiene un watch
        // sobre userFacilitatorId que llama a fetchData()
      },
      immediate: true,
    },
  },
  computed: {
    customStatesSessions: function () {
      return this.$store.state.form?.optionsStatesSessionsFacilitator?.filter(
        (entity) => entity.id !== 0,
      );
    },
    customEntities: function () {
      return this.$store.state.form?.optionsAllCompanies?.filter(
        (entity) => entity.is_agiliza === true,
      );
    },
    customIdentificationType: function () {
      return this.$store.state.form?.optionsIdentificationType?.filter(
        (identification) => identification.id != 3,
      );
    },
    formOptions: function () {
      return this.$store.state.form;
    },
  },
};
</script>

<style>
#filterSupportForm {
  width: 100%;
}
</style>
